import React from 'react';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';

import Segmented from './Segmented';

export const EMPTY_DEPOSIT = {
  depositType: 'percent', value: '', dueDateType: 'relative', days: '', specificDate: '',
};

const DepositRows = ({ deposits, onChange }) => {
  const update = (index, patch) => {
    onChange(deposits.map((d, i) => (i === index ? { ...d, ...patch } : d)));
  };
  const remove = (index) => onChange(deposits.filter((_, i) => i !== index));
  const add = () => onChange([...deposits, EMPTY_DEPOSIT]);

  return (
    <section className="simple-offer__section">
      <h3 className="simple-offer__section-title">DEPOSITS</h3>

      {deposits.map((d, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="simple-offer__deposit-row" data-testid="deposit-row" key={i}>
          <div className="simple-offer__field">
            <span className="simple-offer__label">Deposit type</span>
            <Segmented
              ariaLabel="Deposit type"
              value={d.depositType}
              options={[{ value: 'percent', label: 'Percent' }, { value: 'flat', label: 'Flat' }]}
              onChange={(v) => update(i, { depositType: v })}
            />
          </div>

          <label className="simple-offer__field">
            <span className="simple-offer__label">Amount</span>
            <input
              data-testid="deposit-value"
              className="simple-offer__input"
              type="number"
              value={d.value}
              onChange={(e) => update(i, { value: e.target.value })}
            />
          </label>

          <div className="simple-offer__field">
            <span className="simple-offer__label">Due date</span>
            <Segmented
              ariaLabel="Due date type"
              value={d.dueDateType}
              options={[{ value: 'relative', label: 'Relative' }, { value: 'specific', label: 'Specific' }]}
              onChange={(v) => update(i, { dueDateType: v })}
            />
          </div>

          {d.dueDateType === 'relative' ? (
            <label className="simple-offer__field">
              <span className="simple-offer__label">Days</span>
              <input
                data-testid="deposit-days"
                className="simple-offer__input"
                type="number"
                value={d.days}
                onChange={(e) => update(i, { days: e.target.value })}
              />
              <span className="simple-offer__hint">days before event</span>
            </label>
          ) : (
            <label className="simple-offer__field">
              <span className="simple-offer__label">Date</span>
              <Flatpickr
                data-testid="deposit-date"
                className="simple-offer__input"
                placeholder="Select date"
                options={{ dateFormat: 'Y-m-d' }}
                value={d.specificDate}
                onChange={(dates, dateStr) => update(i, { specificDate: dateStr })}
              />
            </label>
          )}

          <button
            type="button"
            data-testid="delete-deposit"
            className="simple-offer__icon-btn"
            aria-label="Delete deposit"
            onClick={() => remove(i)}
          >
            <i className="far fa-trash" aria-hidden="true" />
          </button>
        </div>
      ))}

      <button type="button" data-testid="add-deposit" className="simple-offer__add-link" onClick={add}>
        + Add deposit
      </button>
    </section>
  );
};

DepositRows.propTypes = {
  deposits: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DepositRows;
